import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Injector, OnInit} from '@angular/core';
import { BaseComponent } from '../../base.component';
import { SnackBarUtil } from '../../../util/snack.bar.util';
import { PlatformService } from '../../../util/service/platform.service';
import { FAQ_ITEMS, FaqItem } from '../../../common/faq';

/**
 * سوالات متداول صفحه‌ی اصلی، با ظاهر طرح جدید (باز و بسته شدن با +/−).
 * همه‌ی سوال‌ها در HTML خروجی هستند؛ بعد از پنج‌تای اول فقط پنهان‌اند تا
 * موتورهای جست‌وجو هم ببینندشان.
 */
@Component({
  selector: 'app-acc-expansion-panel',
  templateUrl: './acc-expansion-panel.component.html',
  styleUrl: './acc-expansion-panel.component.scss',
  standalone: true,
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccExpansionPanelComponent extends BaseComponent implements OnInit {
  supportNumbers: string ='09105698040'
  rules: any;
  // نسخه‌ی قابل تغییر؛ شماره‌ی پشتیبانی و آدرس بعداً از سرویس جایگزین می‌شوند
  questionsAndAnswers: FaqItem[] = FAQ_ITEMS.map(item => ({...item}));
  /** تعداد سوال‌هایی که پیش از «نمایش همه» دیده می‌شوند (مثل طرح) */
  readonly visibleCount = 5;
  showAll = false;

  constructor(
    injector: Injector,
    private platformServicef: PlatformService,
    private cdr: ChangeDetectorRef,
    private platform: PlatformService
  ) {
    super(injector);
  }
  
  override ngOnInit(): void {
    if (this.platformServicef.isServer()) return;

    this.getSupportNumber();
    this.getRules();
  }

  getSupportNumber() {
    this.serviceApi.getPublicConfig('SUPPORT_PHONE_NUMBER').subscribe((res) => {
      if (res == null) {
        SnackBarUtil.makeMessageWithAction(this, this.strings.problem_on_connecting_to_server, this.strings.retry, () => {
          this.loadOnline();
        });
        return;
      }

      if (res.data) {
        this.supportNumbers = res.data;
      
        // آرایه رو با یک کپی جدید بازسازی کن تا reference عوض بشه
        const updated = [...this.questionsAndAnswers];
        updated[7] = {
          ...updated[7],
          answer: `پشتیبانی از ساعت ۹ صبح تا ۱۸ عصر به صورت تلفنی در خدمت کاربران است. شماره تماس: ${this.supportNumbers}.`
        };
        
        this.questionsAndAnswers = updated;
      
        this.cdr.markForCheck(); // حالا OnPush متوجه تغییر میشه 🎯
      } else {
        SnackBarUtil.makeMessage(this, res.error!);
      }
    })
  }

  getRules() {
    if (this.platform.isServer()) return;

    this.serviceApi.getRules().subscribe((res) => {
      if (!res) {
        SnackBarUtil.makeMessageWithAction(
          this,
          this.strings.problem_on_connecting_to_server,
          this.strings.retry,
          () => this.loadOnline()
        );
        return;
      }
  
      if (res.data) {
        this.rules = res.data;
  
        // 🔥 آپدیت سوال آدرس بعد از دریافت rules
        const updated = [...this.questionsAndAnswers];
        const addressIndex = updated.findIndex(
          q => q.question === 'آدرس مجموعه بازَر کجاست؟'
        );
  
        if (addressIndex !== -1) {
          updated[addressIndex] = {
            ...updated[addressIndex],
            answer: this.rules.address
          };
        }
  
        this.questionsAndAnswers = updated;

        this.cdr.markForCheck(); // 👈 خیلی مهم برای OnPush
      } else {
        SnackBarUtil.makeMessage(this, res.error!);
      }
    });
  }

  toggleAll() {
    this.showAll = !this.showAll;
  }
}
